import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadSupplierFormComponent } from '../upload-supplier-form/upload-supplier-form.component'
import { SupplierService } from 'src/app/services/supplier/supplier.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
@Component({
  selector: 'app-supplier',
  templateUrl: './upload-supplier.component.html',
  styleUrls: ['./upload-supplier.component.scss']
})
export class UploadSupplierComponent implements OnInit {
  @ViewChild(UploadSupplierFormComponent, {static: false}) child;
  private sub:any;
  public params:any;
  public supplier:any;
  public supplierUsers: any[] = [];
  public filteredSupplierUsers: any[] = [];
  public filteredHeader: string;
  public promptDeleteUser: boolean = false;
  public userToDelete: any;
  public loading: boolean= false;
  public p: any;
  public masterLocation = {};
  public poCount = 0;
  public selected = 'users';
  public customers: any;

  constructor(private router: Router, private supplierService:SupplierService, private location:Location, private route:ActivatedRoute, public currentUserService:CurrentUserService) { }

  ngOnInit() {
    this.supplierService.pageUrl.next(this.router.url);
    //this.loading = true;
  }
}
